import { render } from "./Test.vue?vue&type=template&id=0602bd1f&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=0602bd1f&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0602bd1f"]])

export default __exports__